import { Dispatch } from 'redux'

import * as AuthenticationApi from 'redux/api/Authentication'

import { signOut as signOutFunction } from 'App/Auth/AuthModule'

import { useThunkActions } from 'redux/actions/useThunkActions'
import { clearActiveVariant } from 'redux/actions/TestEnvironment'

import * as actions from './actions'

/**
 * Validates the session against the backend and populates the signed-in
 * state (account, customer, permissions). Signs out on an invalid
 * session.
 *
 * Called from App/Auth once the Cognito session is valid; a successful
 * validation is the precondition for initializeApp (redux/actions/AppInit).
 */
export function tryValidateUser(callback?: (err?: boolean) => void) {
  return (dispatch: Dispatch) => {
    dispatch(actions.validateUser())

    AuthenticationApi.whoAmI()
      .then((response) => {
        dispatch(actions.setSignedIn(response.data.data.attributes))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        // Invalid session — sign out.
        clearActiveVariant()

        signOutFunction().then(() => {
          dispatch(actions.signOut())
        })

        if (callback) {
          callback(true)
        }
      })
  }
}

export function signOut() {
  return (dispatch: Dispatch) => {
    clearActiveVariant()

    signOutFunction().then(() => {
      dispatch(actions.signOut())
    })
  }
}

export const useAuthenticationActions = () => {
  return {
    tryValidateUser: useThunkActions(tryValidateUser),
    signOut: useThunkActions(signOut)
  }
}
